var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10715_92755)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7721 2.68897C11.1232 2.41586 11.5553 2.26758 12.0001 2.26758C12.4449 2.26758 12.877 2.41586 13.2281 2.68897L21.6121 9.20897C22.3651 9.79597 21.9491 11.001 20.9971 11.001H20.0001V19.001C20.0001 19.5314 19.7894 20.0401 19.4143 20.4152C19.0392 20.7903 18.5305 21.001 18.0001 21.001H6.0001C5.46967 21.001 4.96096 20.7903 4.58589 20.4152C4.21082 20.0401 4.0001 19.5314 4.0001 19.001V11.001H3.0031C2.0501 11.001 1.6361 9.79497 2.3881 9.20997L10.7721 2.68897ZM5.6251 9.22597C5.8541 9.41097 6.0001 9.69397 6.0001 10.011V19.001H18.0001V10.011C18.0001 9.69397 18.1461 9.41097 18.3751 9.22597L12.0001 4.26797L5.6251 9.22597Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10715_92755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.208bfddad64ee00444907b2233c72b1e.svg";
export { ForwardRef as ReactComponent };